import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SurveyDetailsPage } from 'src/app/models/survey.model';
import { SurveyService } from 'src/app/services/survey.service';
import { DtService } from 'src/app/services/dt.service';
import { MeterService } from 'src/app/services/meter.service';
import { PermissionsEnum } from 'src/app/models/role.model';
import { TranslationService } from 'src/app/services/translation.service';
import { AuthService, CimSubstationService, PermissionsService } from 'shared-lib';
import { OptionObj } from 'src/app/models/util.model';
import { User } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
import { DeferredToastService } from 'src/app/services/deferred-toast.service';

@Component({
  selector: 'app-survey-details',
  templateUrl: './survey-details.component.html',
  styleUrls: ['./survey-details.component.scss'],
})
export class SurveyDetailsComponent implements OnInit {
  public PermissionsEnum = PermissionsEnum;

  id: string = '';
  selectedSurvey: SurveyDetailsPage = new SurveyDetailsPage();
  selectedImage: any;
  rejectionNote: string = '';
  editEnabled: boolean = false;

  dtOptions: OptionObj[] = [];
  substationOptions: any[] = [];
  meterBrandOptions: OptionObj[] = [];
  buName: string = this.translationService.getByKeyFromStorage('BU');
  utName: string = this.translationService.getByKeyFromStorage('UT');
  contractNumber: string =
    this.translationService.getByKeyFromStorage('Contract number');
  imgElement: any;
  imgZoomFullContainer: any;
  currentRotation: number = 0;
  isGhanaPostFieldsVisible: boolean = true;
  isSPNFieldVisible: boolean = true;
  isGeoCodeFieldVisible: boolean = true;
  isActivityCodeFieldVisible: boolean = true;
  isCurrentPlotCodeFieldVisible: boolean = true;
  isBlockNumberFieldVisible: boolean = true;
  isMeterLocationFieldVisible: boolean = true;
  isExistingBillOfPaymentFieldVisible: boolean = true;
  isInstallationMaterialRequirementVisible: boolean = true;
  isMapVisible: boolean = false;
  isImageMapVisible: boolean = false;
  filterText = '';
  tempAssignedUserId: number = 0;
  mobileUsers: User[] = [];
  isDropdownOpened: boolean = false;
  filteredMobileUsers: User[] = [];
  rejectToOption: string;
  resendEmail: string = '';
  timeZone: any;
  canRecallSurvey: boolean = false;

    hasCimDataIntegration: boolean = false;


  @ViewChild('closeResendModal') closeResendModal: ElementRef<HTMLButtonElement>;

  constructor(
    private route: ActivatedRoute,
    private surveyService: SurveyService,
    private toastr: ToastrService,
    public permissionsService: PermissionsService,
    private dtService: DtService,
    private meterService: MeterService,
    private translationService: TranslationService,
    private userService: UserService,
    private el: ElementRef,
    private renderer: Renderer2,
    private deferredToastService: DeferredToastService,
    private authService: AuthService,
    private cimSubstationService: CimSubstationService,
  ) {
      this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
  }

  ngOnInit(): void {
    this.setFieldsVisibility();
    this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.id = this.route.snapshot.paramMap.get('id') || '';
    this.imgElement = this.el?.nativeElement?.querySelector(
      '.ngxImageZoomThumbnail'
    );
    this.imgZoomFullContainer =
      this.el?.nativeElement?.querySelector('.ngxImageZoomFull');

    this.getSelectedSurvey(parseInt(this.id));
    this.getMeterBrandsForOptions();
    this.deferredToastService.showQueuedMessage();
  }

  getMeterBrandsForOptions() {
    this.meterService.getMeterTypesForOptions().subscribe(
      (response) => {
        this.meterBrandOptions = response.body.data;
      },
      (error) => {
        this.toastr.error('An error occurred.');
      }
    );
  }

  getPlannedMeterBrandName() {
    return this.meterBrandOptions.find(
      (option) => option.key == this.selectedSurvey.plannedMeterBrandId
    )?.value || '';
  }

  getSelectedSurvey(id: number) {
    this.surveyService.getDetailsById(id).subscribe(
      (data) => {
        if (!data.body?.data) { this.toastr.error('An error occurred with fetching survey details.'); return; }
        this.selectedSurvey = data.body.data;
        this.selectedSurvey.serviceRequestHistory = [...(this.selectedSurvey.serviceRequestHistory ?? [])].sort((a, b) =>
          new Date(b.applicationDate ?? 0).getTime() - new Date(a.applicationDate ?? 0).getTime()
        );
        if (this.selectedSurvey.dt?.feederId)
          this.getDtsForOptions(parseInt(this.selectedSurvey.dt.feederId));
        if (this.selectedSurvey.substation?.acLineId)
          this.getSubstationsForOptions(this.selectedSurvey.substation.acLineId);
        if (this.selectedSurvey.surveyInstallationStatus == 'Approved')
          this.checkCanRecallSurvey(id);
      },
      (error) => {
        this.toastr.error('An error ocurred.');
      }
    );
  }

  checkCanRecallSurvey(id: number) {
    this.surveyService.canRecallSurvey(id, this.selectedSurvey.projectType).subscribe(
      (data) => {
        this.canRecallSurvey = data.body?.data === true;
      },
      (error) => {
        this.toastr.error('An error occurred while checking if the survey can be recalled.');
      }
    );
  }

  recall() {
    this.surveyService.recallSurvey(parseInt(this.id)).subscribe(
      (data) => {
        var response = data.body;
        if (response.status === 'OK') {
          this.deferredToastService.queueSuccess("Survey recalled sucessfully.")
          window.location.reload();
        } else {
          this.toastr.error(response.message || "Survey is not recalled, something went wrong.")
        }
      })
  }

  showImage(num: number) {
    if (num === 8) {
      this.selectedImage = this.getImageByType('MeterNumber');
    } else if (num === 7) {
      this.selectedImage = this.getImageByType('CustomerSignature');
    } else if (num == 6) {
      this.selectedImage = this.getImageByType('FieldRepSignature');
    } else if (num == 5) {
      this.selectedImage = this.getImageByType('BillOrPaymentReceipts');
    } else if (num == 4) {
      this.selectedImage = this.getImageByType('RecommendedMeteringPoint');
    } else if (num == 3) {
      this.selectedImage = this.getImageByType('ExistingMeteringPoint');
    } else if (num == 2) {
      this.selectedImage = this.getImageByType('ServiceCableFromPole');
    } else if (num == 1) {
      this.selectedImage = this.getImageByType('Frontview');
    }
  }

  getImageByType(imageType: string) {
    return this.selectedSurvey.images?.find((x) => x.imageType === imageType);
  }

  onOptionChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.rejectToOption = target.value;
    this.tempAssignedUserId = 0;
    this.filterText = '';
  }

  filterMobileUsers() {
    if (this.filterText.length < 3) {
      return;
    }
    this.isDropdownOpened = true;
    this.tempAssignedUserId = 0;
    this.getMobileUsers();
  }

  getMobileUsers() {
    this.userService.getMobileUsers(0, this.filterText).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.mobileUsers = responseData.data;
          if (this.mobileUsers.length == 0) {
            this.isDropdownOpened = false;
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  selectFieldAgent(id: number) {
    this.isDropdownOpened = false;
    this.tempAssignedUserId = id;
    var mobUser = this.mobileUsers.find((x) => x.id == id);
    if (mobUser?.firstName && mobUser?.lastName) {
      this.filterText = mobUser!.firstName + ' ' + mobUser?.lastName;
    } else {
      this.filterText = mobUser!.firstName;
    }
  }

  approve() {
    this.surveyService.approveSurvey(parseInt(this.id)).subscribe(
      (data) => {
        if (data.status !== 'OK') { this.toastr.error(data.message) }
        else if (data.message != null && data.message != "") { this.toastr.info(data.message) } else {
          this.toastr.success('Survey Approved');
          window.location.reload();
        }
      },
      (error) => {
        this.toastr.error('An error ocurred.');
      }
    );
  }

  openResend() {
    this.resendEmail = this.selectedSurvey?.customer?.email ?? '';
  }

  resendInvoice() {
    if (!this.resendEmail || this.resendEmail.trim() === '') {
      this.toastr.warning('Please enter a customer email address');
      return;
    }

    const email = this.resendEmail.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      this.toastr.warning('Please enter a valid email address');
      return;
    }

    const obj = {
      surveyId: parseInt(this.id),
      email: email,
    };

    this.surveyService.resendInvoice(obj).subscribe(
      (data) => {
        const response = data.body;
        if (response?.status === 'OK') {
          this.toastr.success('Invoice sent successfully');
          this.closeResendModal?.nativeElement.click();
        } else {
          this.toastr.error(response?.message);
        }
      },
      (error) => {
        this.toastr.error('An error ocurred.');
      }
    );
  }

  reject() {
    let obj = {
      id: parseInt(this.id),
      note: this.rejectionNote,
      assignToId: this.tempAssignedUserId,
    };
    if (this.rejectToOption === 'fieldAgent' && this.tempAssignedUserId === 0)
      this.toastr.error('Select field Agent');
    else
      this.surveyService.rejectSurvey(obj).subscribe(
        (data) => {
          this.toastr.success('Survey Rejected');
          window.location.reload();
        },
        (error) => {
          this.toastr.error('An error ocurred.');
        }
      );
  }

  validate() {
    let obj = {
      id: parseInt(this.id),
      customer: this.selectedSurvey.customer,
    };
    this.surveyService.validateSurvey(obj).subscribe(
      (data) => {
        this.toastr.success('Survey Validated');
        window.location.reload();
      },
      (error) => {
        this.toastr.error('An error ocurred.');
      }
    );
  }

  getCustomersSignature() {
    return this.selectedSurvey.images?.find(
      (x) => x.imageType === 'CustomerSignature'
    )?.url;
  }
  getFieldRepSignature() {
    return this.selectedSurvey.images?.find(
      (x) => x.imageType === 'FieldRepSignature'
    )?.url;
  }
  getMeterNumber() {
    return this.selectedSurvey.images?.find(
      (x) => x.imageType === 'MeterNumber'
    )?.url;
  }
  getReceipts() {
    return this.selectedSurvey.images?.find(
      (x) => x.imageType === 'BillOrPaymentReceipts'
    )?.url;
  }
  getRecommendedMeterPoint() {
    return this.selectedSurvey.images?.find(
      (x) => x.imageType === 'RecommendedMeteringPoint'
    )?.url;
  }
  getExistingMeterPoint() {
    return this.selectedSurvey.images?.find(
      (x) => x.imageType === 'ExistingMeteringPoint'
    )?.url;
  }
  getFrontView() {
    return this.selectedSurvey.images?.find((x) => x.imageType === 'Frontview')
      ?.url;
  }
  getServiceCable() {
    return this.selectedSurvey.images?.find(
      (x) => x.imageType === 'ServiceCableFromPole'
    )?.url;
  }

  getDtsForOptions(feederId: number) {
    this.dtService
      .getAllForSelectByFeeder(
        feederId,
        this.selectedSurvey.dt?.feederType?.toString()
      )
      .subscribe(
        (response) => {
          this.dtOptions = response.body.data;
        },
        (error) => {
          this.toastr.error('An error occurred.');
        }
      );
  }

  getSubstationsForOptions(acLineId: number) {
    this.cimSubstationService
      .getAllSubstationsCached({ voltageClasses: [1] })
      .subscribe(
        (response: any) => {
          this.substationOptions = (response.body?.data ?? []).filter((s: any) =>
            (s.incomingACLines ?? []).some((l: any) => l.id === acLineId)
          );
        },
        (error) => {
          this.toastr.error('An error occurred.');
        }
      );
  }

  edit() {
    this.editEnabled = !this.editEnabled;
  }

  onModalFade() {
    this.currentRotation = 0;

    if (this.imgZoomFullContainer) {
      var displayValue = getComputedStyle(this.imgZoomFullContainer).display;

      if (displayValue == 'block') {
        this.imgElement.click();
      }
    }
  }

  rotateLeft() {
    this.currentRotation -= 90;
  }

  rotateRight() {
    this.currentRotation += 90;
  }

  onModalOpen() {
    this.renderer.setStyle(document.body, 'overflow', 'auto');
    this.renderer.setStyle(document.body, 'overflow-x', 'hidden');
    this.renderer.setStyle(document.body, 'padding-right', '0');
  }

  setFieldsVisibility() {
    let notVisibleFields: any = localStorage.getItem('notVisibleFields');

    if (!notVisibleFields) {
      return;
    }

    notVisibleFields = JSON.parse(notVisibleFields);
    this.isGhanaPostFieldsVisible = notVisibleFields.find(
      (el: any) => el === 'ghanaPostCode'
    )
      ? false
      : true;

    this.isSPNFieldVisible = notVisibleFields.find(
      (el: any) => el === 'spn'
    )
      ? false
      : true;

    this.isGeoCodeFieldVisible = notVisibleFields.find(
      (el: any) => el === 'geoCode'
    )
      ? false
      : true;

    this.isActivityCodeFieldVisible = notVisibleFields.find(
      (el: any) => el === 'activityCode'
    )
      ? false
      : true;

    this.isCurrentPlotCodeFieldVisible = notVisibleFields.find(
      (el: any) => el === 'currentPlotCode'
    )
      ? false
      : true;

    this.isBlockNumberFieldVisible = notVisibleFields.find(
      (el: any) => el === 'blockNumber'
    )
      ? false
      : true;

    this.isExistingBillOfPaymentFieldVisible = notVisibleFields.find(
      (el: any) => el === 'existingBillOfPaymentPicture'
    )
      ? false
      : true;

    this.isMeterLocationFieldVisible = notVisibleFields.find(
      (el: any) => el === 'meterLocation')
      ? false
      : true;
    this.isInstallationMaterialRequirementVisible = notVisibleFields.find(
      (el: any) => el === 'installationMaterialRequirement'
    )
      ? false
      : true;
  }
}
